import { Component, Input } from '@angular/core';
import { GamificationCardsService } from '../services/gamification-cards.service';
import { CommonModule } from '@angular/common';

type Prompt = {
  prompt_id: number;
  title: string;
  description: string;
  created_datetime: string;
  execution_count: number;
  total_feedbacks: number;
  average_rating: number;
  total_views: number;
};

type TrendingPrompt = {
  category_id: number;
  category_name: string;
  prompts: Prompt[];
};

type Consumer = {
  average_rating: number;
  consumer_user_id: number;
  email: string;
  execution_count: number;
  firstname: string;
  lastname: string;
  role_name: string;
  username: string;
};

type TrendingConsumer = {
  category_id: number;
  category_name: string;
  consumers: Consumer[];
};

type Creator = {
  average_rating: number;
  created_count: number;
  creator_user_id: number;
  email: string;
  firstname: string;
  lastname: string;
  role_name: string;
  username: string;
};

type TrendingCreator = {
  category_id: number;
  category_name: string;
  creators: Creator[];
};

type Curator = {
  approval_count: number;
  average_rating: number;
  curator_user_id: number;
  email: string;
  firstname: string;
  lastname: string;
  role_name: string;
  username: string;
};

type TrendingCurator = {
  category_id: number;
  category_name: string;
  curators: Curator[];
};

@Component({
  selector: 'app-gamification-cards',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './gamification-cards.component.html',
  styleUrl: './gamification-cards.component.scss',
})
export class GamificationCardsComponent {
  @Input() isDrawerOpen: boolean = false;
  @Input() userId: number = 1;
  numberOfCategoriesForPrompts: number = 5;
  numberOfCategoriesForConsumers: number = 5;
  numberOfCategoriesForCreators: number = 5;
  numberOfCategoriesForCurators: number = 5;
  activeCategoryForPrompts: number = 1;
  activeCategoryForConsumers: number = 1;
  activeCategoryForCreators: number = 1;
  activeCategoryForCurators: number = 1;
  trendingPrompts: TrendingPrompt[] = [];
  trendingConsumers: TrendingConsumer[] = [];
  trendingCreators: TrendingCreator[] = [];
  trendingCurators: TrendingCurator[] = [];

  constructor(private gamificationCardsService: GamificationCardsService) {}
  ngOnInit() {
    this.getTrendingPrompts();
    this.getTrendingConsumers();
    this.getTrendingCreators();
    this.getTrendingCurators();
  }

  incrementCategory(segment = '') {
    if (segment === 'prompts') {
      if (this.activeCategoryForPrompts < this.numberOfCategoriesForPrompts)
        this.activeCategoryForPrompts++;
    } else if (this.userId == 4) {
      if (this.activeCategoryForConsumers < this.numberOfCategoriesForConsumers)
        this.activeCategoryForConsumers++;
    } else if (this.userId == 3) {
      if (this.activeCategoryForCreators < this.numberOfCategoriesForCreators)
        this.activeCategoryForCreators++;
    } else if (this.userId == 2) {
      if (this.activeCategoryForCurators < this.numberOfCategoriesForCurators)
        this.activeCategoryForCurators++;
    }
  }

  decrementCategory(segment = '') {
    if (segment === 'prompts') {
      if (this.activeCategoryForPrompts > 1) this.activeCategoryForPrompts--;
    } else if (this.userId == 4) {
      if (this.activeCategoryForConsumers > 1)
        this.activeCategoryForConsumers--;
    } else if (this.userId == 3) {
      if (this.activeCategoryForCreators > 1) this.activeCategoryForCreators--;
    } else if (this.userId == 2) {
      if (this.activeCategoryForCurators > 1) this.activeCategoryForCurators--;
    }
  }

  getTrendingPrompts() {
    this.gamificationCardsService.getTrendingPrompts().subscribe((response) => {
      this.numberOfCategoriesForPrompts = response.data?.length;
      this.trendingPrompts = response.data;
    });
  }

  getTrendingConsumers() {
    this.gamificationCardsService
      .getTrendingConsumers()
      .subscribe((response) => {
        this.numberOfCategoriesForConsumers = response.data?.length;
        this.trendingConsumers = response.data;
      });
  }

  getTrendingCreators() {
    this.gamificationCardsService
      .getTrendingCreators()
      .subscribe((response) => {
        this.numberOfCategoriesForCreators = response.data?.length;
        this.trendingCreators = response.data;
      });
  }

  getTrendingCurators() {
    this.gamificationCardsService
      .getTrendingCurators()
      .subscribe((response) => {
        this.numberOfCategoriesForCurators = response.data?.length;
        this.trendingCurators = response.data;
      });
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);

    // Get the day, month, and year
    const day = date.toLocaleString('en-US', { day: '2-digit' });
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.toLocaleString('en-US', { year: 'numeric' });

    // Construct the desired format
    return `${day} ${month}, ${year}`;
  }
}
